import React, { useState } from "react";
import { AiOutlinePlus, AiOutlineMinus, AiOutlineCheck } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { deleteItem } from "../../containers/rtk/slices/slice";
import "./CartBlock.scss";
const CartBlock = (props) => {
  // start increase func
  const [qty, setqty] = useState(props.quantity);
  const increaseqty = () => {
    setqty((prevqty) => {
      let newqty = prevqty + 1;
      return newqty;
    });
  };

  const decreaseeqty = () => {
    setqty((prevqty) => {
      let newqty = prevqty - 1;
      if (newqty < 1) {
        newqty = 1;
      }
      return newqty;
    });
  };

  const dispatch = useDispatch();
  return (
    <>
      <div className="cart_block">
        <img src={props.img} alt="cartimg"></img>
        <div className="title">
          <h3>{props.name}...</h3>
          <span>
            <AiOutlineCheck />
            &nbsp; 2XL
          </span>
        </div>
        <div className="count">
          <button className="decrese" onClick={() => decreaseeqty()}>
            <AiOutlineMinus />
          </button>
          <span>{qty}</span>
          <button className="increase" onClick={() => increaseqty()}>
            <AiOutlinePlus />
          </button>
        </div>
        <div className="price">
          <span> {qty * props.price}</span>
          <br></br>
          <br></br>
          <br></br>

          <button
            className="remove"
            onClick={() => dispatch(deleteItem(props.itemdetails))}
          >
            remove
          </button>
        </div>
      </div>
    </>
  );
};

export default CartBlock;
